import axios from "axios";
import profileApi from "./profileApi";
import { API_CONFIG } from "../config/api.config";

const API_BASE_URL = API_CONFIG.BASE_URL;

// Create axios instance with default headers
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

const enhancedProfileApi = {
  // Existing endpoints
  ...profileApi,

  // New endpoints for updates
  updateBasicProfile: async (userId, profileData) => {
    try {
      const response = await apiClient.put(
        `/profile/basic/${userId}`,
        profileData
      );
      return response.data;
    } catch (error) {
      console.error("Error updating basic profile:", error);
      throw error;
    }
  },

  updatePreferences: async (userId, preferences) => {
    try {
      if (!userId) {
        throw new Error("User ID is required");
      }

      if (!preferences || typeof preferences !== "object") {
        throw new Error("Preferences data is required and must be an object");
      }

      const response = await apiClient.put(
        `/profile/preferences/${userId}`,
        preferences
      );
      return response.data;
    } catch (error) {
      console.error("Error updating preferences:", error);
      throw error;
    }
  },

  updateSettings: async (userId, settings) => {
    try {
      const response = await apiClient.put(
        `/profile/settings/${userId}`,
        settings
      );
      return response.data;
    } catch (error) {
      console.error("Error updating settings:", error);
      throw error;
    }
  },

  // File upload
  uploadProfilePicture: async (userId, file) => {
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await axios.post(
        `${API_BASE_URL}/profile/upload-picture/${userId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error uploading profile picture:", error);
      throw error;
    }
  },

  // Booking history with pagination
  getBookingHistory: async (userId, page = 0, size = 10) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/profile/bookings/history/${userId}`,
        {
          params: { page, size },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching booking history:", error);
      throw error;
    }
  },

  // User reviews
  getUserReviews: async (userId) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/profile/reviews/${userId}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching user reviews:", error);
      throw error;
    }
  },
};

export default enhancedProfileApi;
